import React from 'react';
import { CustomIcon } from '../UI';
import './AuditEventCard.scss';

/**
 * Audit Event Card Component
 * Displays individual audit event with change details
 */
const AuditEventCard = ({ event, isExpanded, onToggle }) => {
  const {
    createdAt,
    action,
    entityType,
    entityId,
    actor,
    changes = []
  } = event;

  const formatDate = (dateString) => {
    if (!dateString) return 'Unknown date';
    const date = new Date(dateString);
    return date.toLocaleString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const getActionIcon = () => {
    switch (action) {
      case 'created':
        return 'plus';
      case 'updated':
        return 'edit-03';
      case 'status_update':
        return 'activity';
      case 'delete':
        return 'trash-03';
      default:
        return 'activity';
    }
  };

  const getActionColor = () => {
    switch (action) {
      case 'created':
        return '#34d399';
      case 'updated':
        return '#60a5fa';
      case 'status_update':
        return '#fbbf24';
      case 'delete':
        return '#f97316';
      default:
        return '#6b7280';
    }
  };

  return (
    <div className="audit-event-card">
      <div className="audit-event-card__header" onClick={onToggle}>
        <div className="audit-event-card__icon" style={{ backgroundColor: `${getActionColor()}20` }}>
          <CustomIcon name={getActionIcon()} size={20} style={{ color: getActionColor() }} />
        </div>
        <div className="audit-event-card__info">
          <div className="audit-event-card__title">
            <span className="audit-event-card__action">{action.replace('_', ' ')}</span>
            <span className="audit-event-card__entity">{entityType}</span>
          </div>
          <div className="audit-event-card__meta">
            <span>{formatDate(createdAt)}</span>
            {actor?.actorEmail && (
              <span>by {actor.actorEmail}</span>
            )}
          </div>
        </div>
        <div className="audit-event-card__toggle">
          <CustomIcon
            name={isExpanded ? 'chevron-up' : 'chevron-down'}
            size={16}
          />
        </div>
      </div>

      {isExpanded && (
        <div className="audit-event-card__body">
          {changes.length > 0 ? (
            <div className="audit-event-card__changes">
              {changes.map((change, index) => (
                <div key={index} className="audit-event-card__change">
                  <div className="audit-event-card__change-field">
                    <strong>{change.field}:</strong>
                  </div>
                  <div className="audit-event-card__change-values">
                    <span className="audit-event-card__change-from">
                      {String(change.from || 'N/A')}
                    </span>
                    <span className="audit-event-card__change-arrow">→</span>
                    <span className="audit-event-card__change-to">
                      {String(change.to || 'N/A')}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="audit-event-card__no-changes">
              No detailed changes available
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default AuditEventCard;
